var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[(_vm.allowedScripts)?_c('scripts-list',{attrs:{"allowed-scripts":_vm.allowedScripts,"skip-code-list":_vm.skipCodeList,"custom-fields":_vm.customFields},on:{"save-script":_vm.handleSaveSharedScripts}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }